export const fullScreenButtonClickHandler = (
  tableWrapper: HTMLDivElement,
  lockScroll: () => void,
  unlockScroll: () => void,
) => {
  if (!tableWrapper) {
    return
  }

  const innerTableClientWidth = tableWrapper.querySelector('.table')!.clientWidth

  tableWrapper.classList.toggle('full-screen-table')

  if (tableWrapper.classList.contains('full-screen-table')) {
    lockScroll()
    tableWrapper.setAttribute('style', `--inner-table-width: ${innerTableClientWidth}px`)
  } else {
    unlockScroll()
    tableWrapper.setAttribute('style', `--inner-table-width: unset`)
  }
}
